// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-a-diary__background {
  background: #f3f4f6;
  height: 100vh;
}
.work-a-diary__head {
  display: flex;
}
.work-a-diary__head__button {
  display: flex;
  margin-left: auto;
}
.work-a-diary__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.work-a-diary__dates {
  display: flex;
  margin-top: 20px;
}
.work-a-diary__arrows__left {
  margin-right: 10px;
}
.work-a-diary__arrows__right {
  margin-left: 10px;
}
.work-a-diary__today-button {
  margin-left: 10px;
  margin-right: 10px;
}
.work-a-diary__today-button button {
  height: 40px;
}
.work-a-diary__content .emptyArea .emptyText {
  color: #999;
  font-size: 1.2rem;
}

.work-a-diary-card {
  margin-top: 30px;
  padding: 3%;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.work-a-diary-card__head {
  display: flex;
}
.work-a-diary-card__head__icon {
  margin-right: 10px;
}
.work-a-diary-card__head__text {
  margin-right: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.work-a-diary-card__head__action {
  margin-left: auto;
}
.work-a-diary-card__body {
  margin-top: 20px;
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.work-a-diary-card__body__content {
  width: 70%;
}
.work-a-diary-card__body__comment {
  width: 30%;
}
.work-a-diary-card__body__comment__div {
  width: 74px;
  height: 74px;
  border: 1px solid #e9e9e9;
  border-radius: 50%;
  float: right;
  margin-right: 50px;
  align-items: center;
  display: flex;
  cursor: pointer;
}
.work-a-diary-card__body__comment__icon-number {
  display: flex;
  margin-left: 18px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  color: #868686;
}
.work-a-diary-card__body__comment__number {
  margin-left: 4px;
}
.work-a-diary-card__footer {
  display: flex;
}
.work-a-diary-card__footer__image {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  object-fit: cover;
}
.work-a-diary-card__footer__profile-name {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #868686;
}
.work-a-diary-card__footer__vertical {
  margin-left: 5px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #e9e9e9;
}
.work-a-diary-card__footer__date {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/components/work-a-diary/work-a-diary.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;EACA,aAAA;AADR;AAII;EACI,aAAA;AAFR;AAIQ;EACI,aAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAOI;EACI,aAAA;EACA,gBAAA;AALR;AASQ;EACI,kBAAA;AAPZ;AAUQ;EACI,iBAAA;AARZ;AAYI;EACI,iBAAA;EACA,kBAAA;AAVR;AAYQ;EACI,YAAA;AAVZ;AAgBY;EACI,WAAA;EACA,iBAAA;AAdhB;;AAoBA;EACI,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAjBJ;AAmBI;EACI,aAAA;AAjBR;AAkBQ;EACI,kBAAA;AAhBZ;AAmBQ;EACI,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlBZ;AAqBQ;EACI,iBAAA;AAnBZ;AAuBI;EACI,gBAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBR;AAwBQ;EACI,UAAA;AAtBZ;AAyBQ;EACI,UAAA;AAvBZ;AAyBY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAvBhB;AA0BY;EACI,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBhB;AA2BY;EACI,gBAAA;AAzBhB;AA8BI;EACI,aAAA;AA5BR;AA8BQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA5BZ;AA+BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AA7BZ;AAgCQ;EACI,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AA9BZ;AAiCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AA/BZ","sourcesContent":[".work-a-diary {\n\n    &__background {\n        background: #f3f4f6;;\n        height: 100vh;\n    }\n\n    &__head {\n        display: flex;\n\n        &__button {\n            display: flex;\n            margin-left: auto;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n    }\n\n    &__dates {\n        display: flex;\n        margin-top: 20px;\n    }\n\n    &__arrows {\n        &__left {\n            margin-right: 10px;\n        }\n\n        &__right {\n            margin-left: 10px;\n        }\n    }\n\n    &__today-button {\n        margin-left: 10px;\n        margin-right: 10px;\n\n        button {\n            height: 40px;\n        }\n    }\n\n    &__content {\n        .emptyArea {\n            .emptyText {\n                color: #999;\n                font-size: 1.2rem;\n            }\n        }\n    }\n}\n\n.work-a-diary-card {\n    margin-top: 30px;\n    padding: 3%;\n    background-color: #ffffff;\n    border: 1px solid #f3f5f6;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    border-radius: 8px;\n\n    &__head {\n        display: flex;\n        &__icon {\n            margin-right: 10px;\n        }\n\n        &__text {\n            margin-right: 10px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 18px;\n            line-height: 24px;\n            color: #333333;\n        }\n\n        &__action {\n            margin-left: auto;\n        }\n    }\n\n    &__body {\n        margin-top: 20px;\n        display: flex;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #868686;\n\n        &__content {\n            width: 70%;\n        }\n\n        &__comment {\n            width: 30%;\n\n            &__div {\n                width: 74px;\n                height: 74px;\n                border: 1px solid #e9e9e9;\n                border-radius: 50%;\n                float: right;\n                margin-right: 50px;\n                align-items: center;\n                display: flex;\n                cursor: pointer;\n            }\n\n            &__icon-number {\n                display: flex;\n                margin-left: 18px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 20px;\n                line-height: 20px;\n                color: #868686;\n            }\n\n            &__number {\n                margin-left: 4px;\n            }\n        }\n    }\n\n    &__footer {\n        display: flex;\n\n        &__image {\n            border-radius: 50%;\n            height: 32px;\n            width: 32px;\n            object-fit: cover;\n        }\n\n        &__profile-name {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #868686;\n        }\n\n        &__vertical {\n            margin-left: 5px;\n            margin-right: 5px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #e9e9e9;\n        }\n\n        &__date {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #999999;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
